module.exports = __webpack_public_path__ + "img/logo@2x.6dbf659d.png";